// extracted by mini-css-extract-plugin
module.exports =  {"arrow":"arrow--NIm9a","prev":"prev--UAE_Y","next":"next--N89i1"};